<template>

    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-upload"></i> Importar Arquivo CSV
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <div class="alert alert-warning">
                                        <i class="fa fa-exclamation-circle"></i> Antes de importar a planilha verifique se os cupons de desconto já se encontram no sistema.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-12">
                                    <label>Arquivo (.csv)</label>
                                    <input type="file"
                                           ref="fileInput" class="form-control"
                                           accept=".csv"
                                           @change="setFile">
                                </div>
                            </div>

                            <!-- <div class="form-group row">
                                <div class="col-md-12">
                                    <p><a href="/static/excel/planilha_estoque.xlsx">Clique aqui</a> para baixar o modelo de planilha para importar.</p>
                                </div>
                            </div> -->
                        </div>
                        <div class="card-footer">
                            <div class="form-group row">
                                <div class="col-md-12 text-right">
                                    <button type="button" @click="save" class="btn btn-primary">Importar <i class="fa fa-angle-right"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {isUndefinedOrNullOrEmpty} from '@/services/string';
    import Facade from '../../facade/facade';
    const facade = new Facade();

    export default {
        data() {
            return {
                file: ''
            }
        },
        computed: {
            isAdmin() {
                return facade.isAdmin();
            },
        },
        methods: {
            save() {
                let vm = this;

                if (!isUndefinedOrNullOrEmpty(vm.file)) {
                    this.$swal({
                        title: 'Você tem certeza?',
                        text: "Não será possível reverter esta operação",
                        showCancelButton: true,
                        confirmButtonText: 'Sim, importar!',
                        cancelButtonText: 'Não, cancelar!'
                    }).then(() => {
                        this.$loading.show(true);
                        let model = this.createFormData();
                        let ret = facade.importDiscount(model);
                        ret.then(() => {
                            this.$loading.show(false);
                            this.$swal({
                                title: 'Sucesso!',
                                text: "O arquivo foi importado.",
                                confirmButtonText: 'Ok',
                            }).then(() => {
                              this.file = null;
                              this.$refs.fileInput.value = '';
                            });
                        }).catch(e => {
                            e.forEach((item) => {
                                this.$notify.error(item.field, item.message);
                            });
                            this.$loading.show(false);
                        });
                    }, dismiss => {

                    });
                } else {
                    this.$notify.warning('Atenção!', 'Verifique se todos os campos estão preenchidos corretamente.');
                }
            },
            createFormData() {
                var formData = new FormData();
                formData.append('file', this.file);
                return formData;
            },
            setFile(event) {
                if (event.currentTarget.files) {
                    this.file = event.currentTarget.files[0]
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Import.vue?33962efa